import { render, staticRenderFns } from "./AutoTypeAddEdit.vue?vue&type=template&id=284ded48&scoped=true&"
import script from "./AutoTypeAddEdit.vue?vue&type=script&lang=js&"
export * from "./AutoTypeAddEdit.vue?vue&type=script&lang=js&"
import style0 from "./AutoTypeAddEdit.vue?vue&type=style&index=0&id=284ded48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284ded48",
  null
  
)

export default component.exports